import {Action, ActionFunction1, createAction} from 'redux-actions';

export const NOTIFICATION_SET = 'NOTIFICATION_SET';
export const NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE';

export interface SetNotificationActionPayload {
    type: string;
    text: string;
    manualHide?: boolean;
}

export const setNotificationAction = createAction(NOTIFICATION_SET);
export const closeNotificationAction = createAction(NOTIFICATION_CLOSE);

export const setNotificationError = (text: string) =>
    setNotificationAction({
        type: 'error',
        text,
    });

export type SetNotificationAction = ActionFunction1<
    SetNotificationActionPayload,
    Action<void>
>;
